// Registry for TinyMCE button factories
// This allows shared code to use buttons defined in frontend

let buttonFactories = {};

export const setButtonFactories = (factories) => {
  buttonFactories = { ...buttonFactories, ...factories };
};

export const getButtonFactory = (name) => buttonFactories[name];

export const addSourceWhaleButtonsByToolbar = (toolbar, arg) => {
  if (typeof toolbar === "string") {
    toolbar
      .split(" ")
      .filter((word) => buttonFactories[word])
      .forEach((btn) => {
        buttonFactories[btn](arg);
      });
  } else if (typeof toolbar === "object" && toolbar instanceof Array) {
    toolbar.forEach((tb) => addSourceWhaleButtonsByToolbar(tb, arg));
  }
};
